/**
 * Function toTitleCase
 *
 * Returns a string with the first letters of each word in upper case
 *
 * @param str
 * @returns {string}
 */
function toTitleCase(string) {
    var string = string.toLowerCase().split(' ');
    var words = ['and', 'del', 'della', 'di', 'e'];

    for (var i = 0; i < string.length; i++) {
        if(!words.includes(string[i])) {
            string[i] = string[i].charAt(0).toUpperCase() + string[i].slice(1);
        }
    }

    return string.join(' ');
};

function nl2br (str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

function log(info) {
    if (env != 'prod') {
        console.log(info);
    }
}